import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getShipmentsOrders({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_SHIPPING_ORDERS_REQUEST')

        return axios
            .get(`/shipping-orders/shipping-orders${paginate}${query}`)
            .then(response => {
                commit('GET_SHIPPING_ORDERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_SHIPPING_ORDERS_FAILURE')
                handleApiError(error, 'Pobranie listy zleceń spedycyjnych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShippingOrdersForShippingLabels({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_SHIPPING_ORDERS_FOR_SHIPPING_LABELS_REQUEST')

        return axios
            .get(`/shipping-orders/shipping-orders-for-shipping-labels${paginate}${query}`)
            .then(response => {
                commit('GET_SHIPPING_ORDERS_FOR_SHIPPING_LABELS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_SHIPPING_ORDERS_FOR_SHIPPING_LABELS_FAILURE')
                handleApiError(error, 'Pobranie listy zleceń spedycyjnych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShipmentsOrder(context, id) {
        return axios
            .get(`/shipping-orders/shipping-orders/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych dla zlecenia spedycyjnego ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    getShipmentsOrderChangesHistory(context, id) {
        return axios
            .get(`/shipping-orders/shipping-orders/${id}/changes-history`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie historii zmian dla zlecenia spedycyjnego z ID: ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createShipmentsOrder({ commit }, payload) {
        return axios
            .post('/shipping-orders/shipping-order-from-pm', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zlecenie spedycyjne zostało utworzone.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zlecenia spedycyjnego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateShipmentsOrder({ commit }, shippingOrder) {
        return axios
            .put(`/shipping-orders/shipping-orders/${shippingOrder.id}`, shippingOrder)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zlecenie spedycyjne zostało zapisane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja zlecenia spedycyjnego nie powiodła się.')

                return Promise.reject(error)
            })
    },
    updateShipmentsOrderGoodItem(context, shippingOrderGoodsItem) {
        return axios
            .put(`/shipping-orders/shipping-orders-good-items/${shippingOrderGoodsItem.id}`, shippingOrderGoodsItem)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja towaru zlecenia spedycyjnego nie powiodła się.')

                return Promise.reject(error)
            })
    },
    printShipmentsOrder(context, id) {
        return axios
            .get(`/shipping-orders/shipping-orders/${id}?printShippingOrder=true`, {
                responseType: 'arraybuffer'
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie zlecenia spedycyjnego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPackageBoxTypes() {
        return axios
            .get('/package-definitions/dicts/box-types')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów pakowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPackagesTypes(context, query = '') {
        return axios
            .get(`/package-definitions/dicts/package-types${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów opakowań nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDeliveryMethods(context, {
        query = ''
    } = {}) {
        return axios
            .get(`/deliveries/dicts/delivery-methods${query}`,)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie metod dostawy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getTransportTypes() {
        return axios
            .get('/production-processes/process-property-values?propertyName=transport')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów transportów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShipmentsOrderStatuses({ commit }) {
        return axios
            .get('/shipping-orders/dicts/shipping-order-statuses')
            .then(response => {
                commit('GET_SHIPPING_ORDER_STATUSES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/shipping-orders/shipping-orders?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport po wygenerowaniu zostanie wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createShipmentOrderFromOrders({ commit }, payload) {
        return axios
            .post('/shipping-orders/shipping-order-from-orders', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zlecenie spedycyjne zostało utworzone.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Utworzenie zlecenia spedycyjnego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setShipmentsOrdersFilters({ commit }, filters) {
        commit('SET_SHIPPING_ORDERS_FILTERS', filters)
    },
    clearShipmentsOrdersFilters({ commit }) {
        commit('CLEAR_SHIPPING_ORDERS_FILTERS')
    }
}
